import { MENU_TOTEM } from "../../utils/constants";
import { totemTypes } from "./totemTypes";

const initialState = {
  opciones: [],
  subOpciones: [],
  recepciones: [],
  recepcionesUsuario: [],
  solicitudesRecepcionesUsuario: [],
  solicitudesAfiliados: [],
  afiliados: [],
  turnosAfiliados: [],
  recepcionPisos: [],
  activeBreadcrumb: MENU_TOTEM.DESELECCIONAR
};
export const totemReducer = (state = initialState, action) => {
  switch (action.type) {
    case totemTypes.getOpciones:
      return {
        ...state,
        opciones: action.payload,
      };
    case totemTypes.cleanOpciones:
      return {
        ...state,
        opciones: [],
      };
    case totemTypes.insertOpcion:
      return {
        ...state,
        opciones: [...state.opciones, action.payload],
      };
    case totemTypes.updateOpcion:
      return {
        ...state,
        opciones: state.opciones.map((item) => item.id === action.payload.id ? { ...item, ...action.payload } : item),
      };
    case totemTypes.deleteOpcion:
      return {
        ...state,
        opciones: state.opciones.filter((item) => item.id !== action.payload),
      };

    case totemTypes.getSubOpciones:
      return {
        ...state,
        subOpciones: action.payload,
      };
    case totemTypes.cleanSubOpciones:
      return {
        ...state,
        subOpciones: [],
      };
    case totemTypes.insertSubOpcion:
      return {
        ...state,
        subOpciones: [...state.subOpciones, action.payload],
      };
    case totemTypes.updateSubOpcion:
      return {
        ...state,
        subOpciones: state.subOpciones.map((item) => item.id === action.payload.id ? { ...item, ...action.payload } : item),
      };
    case totemTypes.deleteSubOpcion:
      return {
        ...state,
        subOpciones: state.subOpciones.filter((item) => item.id !== action.payload),
      };

    case totemTypes.getRecepciones:
      return {
        ...state,
        recepciones: action.payload,
      };
    case totemTypes.cleanRecepciones:
      return {
        ...state,
        recepciones: [],
      };
    case totemTypes.insertRecepcion:
      return {
        ...state,
        recepciones: [...state.recepciones, action.payload],
      };
    case totemTypes.updateRecepcion:
      return {
        ...state,
        recepciones: state.recepciones.map((item) => item.id === action.payload.id ? { ...item, ...action.payload } : item),
      };
    case totemTypes.deleteRecepcion:
      return {
        ...state,
        recepciones: state.recepciones.filter((item) => item.id !== action.payload),
      };
    case totemTypes.getRecepcionesUsuario:
      return {
        ...state,
        recepcionesUsuario: action.payload,
      };
    case totemTypes.cleanRecepcionesUsuario:
      return {
        ...state,
        recepcionesUsuario: [],
      };
    case totemTypes.getSolicitudesRecepcionesUsuario:
      return {
        ...state,
        solicitudesRecepcionesUsuario: action.payload,
      };
    case totemTypes.cleanSolicitudesRecepcionesUsuario:
      return {
        ...state,
        solicitudesRecepcionesUsuario: [],
      };
    case totemTypes.insertSolicitudRecepcionUsuario:
      return {
        ...state,
        solicitudesRecepcionesUsuario: [...state.solicitudesRecepcionesUsuario, ...action.payload],
      };
    case totemTypes.cleanSolicitudesAfiliados:
      return {
        ...state,
        solicitudesAfiliados: [],
      };
    case totemTypes.getSolicitudesAfiliados:
      return {
        ...state,
        solicitudesAfiliados: action.payload,
      };
    case totemTypes.updateSolicitudesAfiliados:
      return {
        ...state,
        solicitudesAfiliados: state.solicitudesAfiliados.map((item) => item.id === action.payload.id ? { ...item, ...action.payload } : item),
      };
    case totemTypes.cleanAfiliados:
      return {
        ...state,
        afiliados: [],
      };
    case totemTypes.getAfiliados:
      return {
        ...state,
        afiliados: action.payload,
      };
    case totemTypes.cleanTurnosAfiliados:
      return {
        ...state,
        turnosAfiliados: [],
      };
    case totemTypes.getTurnosAfiliados:
      return {
        ...state,
        turnosAfiliados: action.payload,
      };
    case totemTypes.confirmTurnoAfiliados:
      return {
        ...state,
        turnosAfiliados: state.turnosAfiliados.map((item) => item.id === action.payload.id ? { ...item, ...action.payload } : item),
      }
    case totemTypes.setActiveBreadcrumbTotem:
      return {
        ...state,
        activeBreadcrumb: action.payload,
      };
      case totemTypes.getRecepcionPisos:
        return {
          ...state,
          recepcionPisos: action.payload,
        };
    default:
      return state;
  }
};